import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import FilterRequest from '../../../Spirit/Common/Extensions/Models/FilterRequest';
import NotificationUpdateRequest from '../../../Spirit/Admin/Interfaces/Models/NotificationService/NotificationUpdateRequest';
import SendCustomMessageRequest from '../../../Spirit/Admin/Interfaces/Models/NotificationService/SendCustomMessageRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import PaginationResponseT from '../../../Common/ResponseModels/PaginationResponseT';
import NotificationGetListResponse from '../../../Spirit/Admin/Interfaces/Models/NotificationService/NotificationGetListResponse';
import NotificationGetDetailResponse from '../../../Spirit/Admin/Interfaces/Models/NotificationService/NotificationGetDetailResponse';

export default class NotificationService {
	webApiService: WebApiService;
	GetListEvent = new Events<WsResponseModelT<PaginationResponseT<NotificationGetListResponse>>>();
	UpdateEvent = new Events<WsResponseModelT<Boolean>>();
	SendCustomMessageEvent = new Events<WsResponseModelT<Boolean>>();
	GetDetailEvent = new Events<WsResponseModelT<NotificationGetDetailResponse>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('NotificationService', 'GetList', (res: WsResponseModelT<PaginationResponseT<NotificationGetListResponse>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('NotificationService', 'Update', (res: WsResponseModelT<Boolean>) => {
			self.UpdateEvent.trigger(res);
		});
		webApiService.on('NotificationService', 'SendCustomMessage', (res: WsResponseModelT<Boolean>) => {
			self.SendCustomMessageEvent.trigger(res);
		});
		webApiService.on('NotificationService', 'GetDetail', (res: WsResponseModelT<NotificationGetDetailResponse>) => {
			self.GetDetailEvent.trigger(res);
		});
	}
	GetList(request: FilterRequest = null) { 	
        this.webApiService.send('NotificationService', 'GetList' , request);
    }
	Update(request: NotificationUpdateRequest = null) { 	
        this.webApiService.send('NotificationService', 'Update' , request);
    }
	SendCustomMessage(request: SendCustomMessageRequest = null) { 	
        this.webApiService.send('NotificationService', 'SendCustomMessage' , request);
    }
	GetDetail(id: number = 0) { 	
        this.webApiService.send('NotificationService', 'GetDetail' , id);
    }
	 // async methods
	async getListAsync(request: FilterRequest = null): Promise<PaginationResponseT<NotificationGetListResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async updateAsync(request: NotificationUpdateRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Update.bind(this), this.UpdateEvent)(request);
	}
	async sendCustomMessageAsync(request: SendCustomMessageRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.SendCustomMessage.bind(this), this.SendCustomMessageEvent)(request);
	}
	async getDetailAsync(id: number = 0): Promise<NotificationGetDetailResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetDetail.bind(this), this.GetDetailEvent)(id);
	}
}